import { useMutation } from "@tanstack/react-query";
import { applicationService } from "@/services/application.service";

export function useReportQuestionError(applicationId: string) {
	const mutation = useMutation({
		mutationFn: (data: { examQuestionId: string | number; content: string }) =>
			applicationService().reportQuestionError(
				applicationId,
				data.examQuestionId,
				data.content,
			),
	});

	return {
		reportQuestionError: mutation.mutateAsync,
		isReportingError: mutation.isPending,
	};
}
